import {
  Directive, Input, TemplateRef, ViewContainerRef,
  EmbeddedViewRef, OnDestroy, OnChanges, SimpleChanges
} from '@angular/core';

@Directive({ 
    selector: '[cdPaused]', 
    standalone: false
})
export class CdPausedDirective implements OnChanges, OnDestroy {
  @Input('cdPaused') paused = false;
  @Input() cdPausedTemplate?: TemplateRef<unknown>;

  private view?: EmbeddedViewRef<unknown>;
  private currentTemplate?: TemplateRef<unknown>;

  constructor(private vcr: ViewContainerRef, private tpl: TemplateRef<unknown>) {}

  ngOnChanges(_: SimpleChanges): void {
    const template = this.cdPausedTemplate ?? this.tpl;
    if (this.view == null || this.currentTemplate !== template) {
      this.vcr.clear();
      this.view = this.vcr.createEmbeddedView(template);
      this.currentTemplate = template;
    }

    if (this.paused) {
      this.view.detach();                      
    } 
    else {
      this.view.reattach();                     
      queueMicrotask(() => this.view.detectChanges()); 
    }
  }

  ngOnDestroy(): void { 
    this.view?.reattach();
}
}
